import { ZERO } from 'shared/constants'
import type { Task } from 'shared/graphql/graphql'

export const getIsLegacyTimeline = (task: Task) => {
  const { timeline: taskTimeline } = task

  return !taskTimeline || taskTimeline.length === ZERO
}
